module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre_",
    attrs: {
      "id": "filepos3144"
    }
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHING")]), _vm._v(" I S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EE")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NYTHING")])])]), _c('div', {
    staticClass: "calibre_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Quantum Questions, Quantum Answers")])])])]), _c('div', {
    staticClass: "calibre_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "image",
      "src": "images/00002.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_4"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARRISH")]), _vm._v(", MD")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_5"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "image",
      "src": "images/00003.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_6"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("SENTIENT PUBLICATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be33a50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_001.vue
// module id = 63
// module chunks = 0